import React, { useState } from "react";
import style from "../documentConfig/declarationPage.module.css";
import { useNavigate } from "react-router-dom";
import Table from "../../components/CommonComponents/Table/Table";
import PageHeader from "../../components/pageHeader/pageHeader";

const Tab1Content = () => {
  // return <div>Content for Tab 1</div>;
};

const Tab2Content = () => {
  // return <div>Content for Tab 2</div>;
};

const DeclarationPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [tab, setTab] = useState(1);

  const handleEntriesChange = (e: { target: { value: any; }; }) => {
    setEntriesPerPage(Number(e.target.value));
  };

  const navigate = useNavigate();

  const columns = [
    {
      name: 'Sr. No.',
      selector: (row: any, rowIndex: number | undefined) => ((rowIndex ?? 0) + 1),
      sortable: false,
    },
    {
      name: 'Document Name',
      selector: (row: any) => row.documentName,
      sortable: true,
    },
    {
      name: 'Form Type',
      selector: (row: any) => row.formType,
      sortable: true,
    },
    {
      name: 'Last Publish Date',
      selector: (row: any) => row.lastPublishDate,
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row: any) => (
        <button
          className={
            row.status.toLowerCase() === "active"
              ? style.activeButton
              : style.inactiveButton
          }
        >
          {row.status}
        </button>
      ),
      sortable: true,
    },
    {
      name: 'Action',
      selector: (row: any) => (
        <button
          className={style.editButton}
          onClick={() => { navigate("/new-declaration", { state: { user: row } }) }}
        >
          Edit
        </button>
      ),
      sortable: false,
    },
  ];

  const tableData = [
    {
      srNo: 1,
      documentName: "Acknowledgement",
      formType: "Document Form",
      lastPublishDate: "06/12/2023",
      status: "Active"
    },
    {
      srNo: 2,
      documentName: "Decision",
      formType: "Document Form",
      lastPublishDate: "06/12/2023",
      status: "Active"
    }
    // ... Add more rows as needed 
  ];

  const totalPages = Math.ceil(tableData.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;
  const currentTableData = tableData.slice(startIndex, endIndex);

  const generateTableRows = () => {
    return currentTableData
      .filter(
        (row) =>
          row.documentName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.lastPublishDate.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.status.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .map((row, index) => (
        <tr key={index} className={index % 2 === 0 ? style.whiterow : style.greyrow}>
          <td>{row.srNo}</td>
          <td>{row.documentName}</td>
          <td>{row.formType}</td>
          <td>{row.lastPublishDate}</td>
          <td>
            <button
              className={
                row.status === "Active" ? style.activebutton : style.inactivebutton
              }
            >
              {row.status}
            </button>
          </td>
          <td>
            <button className={style.editbutton}>Edit</button>
          </td>
        </tr>
      ));
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className={style.body}>
      {/* Main content here */}
      <div className={style.bodybox}>
      <PageHeader
          title="Document Config"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={true}
          showAdditionalButton={true}
          buttonTitle="New Document"
          onClick={() => { navigate("/new-declaration") }}
        />
        <div className={style.verificationbox}>
          <div>
            <div className="d-flex" style={{backgroundColor: "#F8F0F0", paddingBottom: "0"}}>
              <p onClick={() => { navigate("/document-config") }}>
                <button className={style.topRoundedButton1 }>Document</button>
              </p>
              <p onClick={() => setTab(2)}>
                <button className={style.topRoundedButton2 }>Declaration</button>
              </p>
            </div>
            {/* {tab === 1 && <Tab1Content />}
            {tab === 2 && <Tab2Content />} */}
          </div>
          <div className={style.inputcontainertable}>
            {/* {table} */}
            <Table columns={columns} data={tableData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeclarationPage;
